import React, {useEffect} from 'react'
import {ErrorMessage, Field} from 'formik'
import {validationRule} from '../../validationRules'
import {Form, Input} from 'antd'
import {Rule} from 'antd/es/form'

interface Props {
  containerClassName?: string
  label?: string
  name: any
  validate?: any
  type?: any
  placeholder?: any
  onChange: any
  className?: any
  errors: any
  touched: any
  labelClassName?: string
  required?: boolean
  disabled?: boolean
  value?: string | number
  as?: string
  min?: string
  avoidKey?: any
  onKeyUp?: any
  mainClassName?: string
  defaultValue?: number | string
  uppercase?: boolean
  maxLength?: number
}

const FormTextBox = React.memo((props: Props) => {
  const {
    containerClassName,
    label,
    name,
    type,
    className,
    errors,
    touched,
    labelClassName,
    required,
    onKeyUp,
    avoidKey,
    value,
    as,
    min,
    defaultValue,
    mainClassName,
    uppercase,
    maxLength,
    ...rest
  } = props

  const inputStyle = uppercase ? {textTransform: 'uppercase'} : {}

  return (
    <div className={label ? 'row mb-6' : mainClassName || 'col-lg-6 '}>
      {label && (
        <label className={`mb-1 fw-bolder fs-6 ${labelClassName || 'col-lg-4'}`}>
          <span className={required ? 'required' : ''}>{label}</span>
        </label>
      )}

      <div className={containerClassName ?? 'col-lg-6 '}>
        <Field
          name={name}
          label={label}
          type={type || 'text'}
          className={className || 'form-control border'}
          autoComplete='off'
          as={as || 'input'}
          min={min}
          onKeyUp={onKeyUp}
          maxLength={maxLength}
          defaultValue={defaultValue}
          {...(avoidKey && {avoidKey: avoidKey})}
          {...(value && {value: value})}
          {...rest}
          style={inputStyle}
          data-cy={`${name}-text-field`}
        />
        <div className='fv-plugins-message-container text-danger fw-bolder small text-start mt-1'>
          <ErrorMessage name={name} component='div' className='field-error-message' />
        </div>
      </div>
    </div>
  )
})

export default FormTextBox

interface ITextProps {
  label: string
  placeholder: string
  name: string
  rules: Rule[] | undefined
}
export const TextField = ({label, placeholder, name, rules}: ITextProps) => {
  return (
    <div>
      <Form.Item label={label} name={name} rules={rules}>
        <Input placeholder={placeholder} />
      </Form.Item>
    </div>
  )
}
